import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bookingFilterFlight',
  pure: false
})
export class BookingFilterFlightPipe implements PipeTransform {

  // transform(list: any[], filter: any): any[] {
  //   if (!list || !filter) return list;
  //   return list.filter(item => {
  //     // 1. TEXT SEARCH (searchBy + searchFreeText)
  //     if (filter.searchFreeText) {
  //       const key = filter.searchBy;
  //       if(key === 'booking_id') {
  //         const searchValue = Array.isArray(filter.searchFreeText)
  //             ? Number(filter.searchFreeText[0])
  //             : Number(filter.searchFreeText);
  //         const bookingId = Number(item?.id);
  //         // exact match
  //         if (isNaN(searchValue) || bookingId !== searchValue) {
  //           return false;
  //         }
  //       } else if (key === 'pnr_ticket')  { 
  //         const searchText = Array.isArray(filter.searchFreeText)
  //           ? String(filter.searchFreeText[0]).trim().toLowerCase().replace(/-/g, '')
  //           : String(filter.searchFreeText).trim().toLowerCase().replace(/-/g, '');
  //         const hasPNR = item?.segments?.some((segment: any) =>
  //           segment?.passengers?.some((passenger: any) => {
  //             const crsPNR = String(passenger?.crs_pnr || '').toLowerCase().replace(/-/g, '');
  //             const airlinePNR = String(passenger?.airline_pnr || '').toLowerCase().replace(/-/g, '');
  //             const ticketNo = String(passenger?.ticket_no || '').toLowerCase().replace(/-/g, '');
  //             return crsPNR.includes(searchText) || airlinePNR.includes(searchText) || ticketNo.includes(searchText);
  //           })
  //         );
  //         if (!hasPNR) return false;
  //       } else if (key === 'flight_no') {
  //         const normalize = (v: any) =>
  //           String(v || '').toLowerCase().replace(/-/g, '');
  //         const searchText = Array.isArray(filter.searchFreeText)
  //           ? normalize(filter.searchFreeText[0])
  //           : normalize(filter.searchFreeText);
  //         const hasFlightNo = item?.segments?.some((segment: any) =>
  //           segment?.routes?.some((route: any) => {
  //             const carrierCode = normalize(route?.carrier_code);
  //             const flightNo = normalize(route?.flight_number);
  //             return carrierCode.includes(searchText) || flightNo.includes(searchText);
  //           })
  //         );
  //         if (!hasFlightNo) return false;
  //       } else if (key === 'traveler_name') {
  //         const searchText = Array.isArray(filter.searchFreeText)
  //           ? String(filter.searchFreeText[0]).trim().toLowerCase()
  //           : String(filter.searchFreeText).trim().toLowerCase();
  //         const hasTravelerName = item?.segments?.some((segment: any) =>
  //           segment?.passengers?.some((passenger: any) => {
  //             const fullName = String(passenger?.first_name + ' ' + (passenger?.last_name || '')).toLowerCase();
  //             return fullName.includes(searchText);
  //           })
  //         );
  //         if (!hasTravelerName) return false;
  //       }
  //     }
  //     // 2. AIRLINE FILTER (carrier_code)
  //     if (filter.airlineList) {
  //       const selectedCodes: string[] = []
  //         .concat(filter.airlineList);
  //       const hasCarrier = item?.segments?.some((segment: any) =>
  //         segment?.routes?.some((route: any) => {
  //           return selectedCodes.includes(route.carrier_code);
  //         })
  //       );
  //       if (!hasCarrier) return false;
  //     }
  //     // 3. TRAVEL DATE
  //     if (filter.travelDate) {
  //       const selectedDate = filter.travelDate;
  //       const hasTRAVELDate = item?.segments?.some((segment: any) =>
  //         segment?.routes?.some((route: any) => {
  //           const depDate = route?.dep_time?.split(' ')[0];
  //           return depDate === selectedDate;
  //         })
  //       );
  //       if (!hasTRAVELDate) return false;
  //     }
  //     // 4. BOOKING STATUS
  //     if (filter.bookingStatus) {
  //       const s = [].concat(filter.bookingStatus || []).map(v => v.toLowerCase());
  //       const st = (item?.booking_status || '').toLowerCase();
  //       if (s.includes('other') || s.includes('others')) {
  //         if (['booked','cancelled'].includes(st)) return false;
  //       } else if (!s.includes(st)) {
  //         return false;
  //       }
  //     }
  //     // 5. PAYMENT STATUS
  //     if (filter.paymentStatus) {
  //       const selected = [].concat(filter.paymentStatus)
  //         .map((v: string) => v.toLowerCase());
  //       const apiStatus = (item?.payment_status?.name || '').toLowerCase();
  //       const mappedStatus = apiStatus === 'charged' ? 'paid' : 'notpaid';
  //       if (!selected.includes(mappedStatus)) return false;
  //     }
  //     return true;
  //   });
  // }

  transform(list: any[], filter: any): any[] {
    if (!Array.isArray(list) || !filter) return list || [];

    const toArr = (v: any) => [].concat(v || []);
    const lower = (v: any) => String(v || '').toLowerCase().trim();
    const normalize = (v: any) => lower(v).replace(/-/g, '');
    return list.filter(item => {
      /* ───────────── 1. TEXT SEARCH ───────────── */
      if (filter.searchFreeText) {
        const key = filter.searchBy;
        const searchText = Array.isArray(filter.searchFreeText)
          ? filter.searchFreeText[0]
          : filter.searchFreeText;
        /* booking_id (number exact match) */
        if (key === 'booking_id') {
          const searchVal = Number(searchText);
          if (Number(item?.id) !== searchVal) return false;
        }
        /* pnr / ticket */
        else if (key === 'pnr_ticket') {
          const s = normalize(searchText);
          const match = item?.segments?.some((seg: any) =>
            seg?.passengers?.some((p: any) =>
              [p?.crs_pnr, p?.airline_pnr, p?.ticket_no]
                .some(v => normalize(v).includes(s))
            )
          );
          if (!match) return false;
        }
        /* flight no / carrier code */
        else if (key === 'flight_no') {
          const s = normalize(searchText);
          const match = item?.segments?.some((seg: any) =>
            seg?.routes?.some((r: any) =>
              normalize(r?.carrier_code).includes(s) ||
              normalize(r?.flight_number).includes(s)
            )
          );
          if (!match) return false;
        }
        /* traveler name */
        else if (key === 'traveler_name') {
          const s = lower(searchText);
          const match = item?.segments?.some((seg: any) =>
            seg?.passengers?.some((p: any) =>
              `${p?.first_name || ''} ${p?.last_name || ''}`
                .toLowerCase()
                .includes(s)
            )
          );
          if (!match) return false;
        }
      }
      /* ───────────── 2. AIRLINE FILTER ───────────── */
      if (filter.airlineList) {
        const codes = toArr(filter.airlineList);
        const match = item?.segments?.some((seg: any) =>
          seg?.routes?.some((r: any) => codes.includes(r?.carrier_code))
        );
        if (!match) return false;
      }
      /* ───────────── 3. TRAVEL DATE ───────────── */
      if (filter.travelDate) {
        const match = item?.segments?.some((seg: any) =>
          seg?.routes?.some((r: any) =>
            r?.dep_time?.split(' ')[0] === filter.travelDate
          )
        );
        if (!match) return false;
      }
      /* ───────────── 4. BOOKING STATUS ───────────── */
      if (filter.bookingStatus) {
        const selected = toArr(filter.bookingStatus).map(lower);
        const status = lower(item?.booking_status);
        if (selected.includes('other') || selected.includes('others')) {
          if (['booked', 'cancelled'].includes(status)) return false;
        } else if (!selected.includes(status)) {
          return false;
        }
      }
      /* ───────────── 5. PAYMENT STATUS ───────────── */
      if (filter.paymentStatus) {
        const selected = toArr(filter.paymentStatus).map(lower);
        const apiStatus = lower(item?.payment_status?.name);
        const mapped = apiStatus === 'charged' ? 'paid' : 'notpaid';
        if (!selected.includes(mapped)) return false;
      }
      return true;
    });
  }
}
